import { AlertOctagon } from 'lucide-react';
import { useMockBannerStore } from '../../../application/stores/mockBannerStore';

/**
 * Loud dev banner shown when VITE_ENABLE_MOCKS=true but the MSW worker failed to start —
 * the app must never fail to a silent white screen (knowledge-tree §6 edge cases).
 */
export function MockFailureBanner() {
  const failure = useMockBannerStore((s) => s.mockFailure);
  if (!failure) return null;
  return (
    <div
      role="alert"
      data-testid="mock-failure-banner"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 999,
        background: 'var(--color-danger)',
        color: '#fff',
        padding: '10px 16px',
        display: 'flex',
        gap: 8,
        alignItems: 'center',
        fontWeight: 700,
        fontSize: 'var(--font-size-sm)',
      }}
    >
      <AlertOctagon size={18} aria-hidden />
      MOCK SERVER FAILED — requests will hit the real network. {failure}
    </div>
  );
}
